
import { tr } from '../translate'

export default {
  props: {
    category: {
      type: Object,
      default: null,
    },
    selectedKey: {
      type: String,
      default: null,
    },
  },
  methods: {
    tr(entry) {
      return tr(entry, this.$i18n.locale)
    },
  },
}
